<template>
  <div class="card mb-4">
    <TableInfoBar
      :total="totalItems"
      v-model:pageSize="pageSize"
      :page-sizes="pageSizes"
      create-label="사용자 등록"
      @create="createData"
      v-model:query="q"
      :searchPlaceholder="'이름 검색'"
      @search="onSearch"
    />

    <div class="card-body px-4 pt-0 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="userList"
        :columns="columns"
        :total="totalItems"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :page-sizes="pageSizes"
        :colgroup="colgroup"
        :rowKey="rowKey"
        empty-message="등록된 사용자가 없습니다."
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <td class="text-center text-sm">{{ totalItems - rowStartIndex - index }}</td>
          <td class="text-center text-sm">{{ item.emplyrId }}</td>
          <td class="text-center text-sm">{{ item.userNm }}</td>
          <td class="text-center text-sm">{{ item.groupDc }}</td>
          <td class="text-center text-sm">
            <CustomBadge
              :level="userSttsLevel[item.emplyrSttusCode] || 'medium'"
              size="sm"
              :label="userSttsLabel[item.emplyrSttusCode] || '알 수 없음'"
            />
          </td>
          <td class="text-center text-sm">{{ item.esntlId }}</td>
          <td class="text-center text-sm">{{ item.sbscrbDe ? formatDate(item.sbscrbDe) : '-' }}</td>
        </template>

      </BaseDataTable>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import TableInfoBar from '@/components/pagination/TableInfoBar.vue';
import SoftButton from '@/components/SoftButton.vue';
import api from '@/api/api';

export default {
  components: { CustomBadge, BaseDataTable, TableInfoBar, SoftButton },
  data() {
    return {
      loading: false,
      userList: [],
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      totalItems: 0,
      sort: 'esntlId',
      columns: [
        { label: 'No.' },
        { label: '아이디' },
        { label: '이름' },
        { label: '권한그룹' },
        { label: '상태' },
        { label: '고유번호' },
        { label: '생성일시' },
      ],
      colgroup: [
        'width:8%'
        ,'width:15%'
        ,'width:15%'
        ,'width:15%'
        ,'width:13%'
        ,'width:14%'
        ,'width:20%'
      ],
      q: "",
      userSttsLabel: {
        P: '정상',
        S: '중지',
        D: '탈퇴'
      },
      // 뱃지 색상 매핑 (원하는대로 조정)
      userSttsLevel: {
        P: 'low',       // 초록
        S: 'medium',    // 주황
        D: 'high'       // 빨강 (필요하면 'very-high'로)
      },
    };
  },
  computed: {
    rowStartIndex() {
      return (this.page - 1) * this.pageSize;
    },
  },
  watch: {
    page() { this.fetchData(); },
    pageSize() { this.fetchData(); },
  },
  mounted() { 
    const { page, size, q, sort } = this.$route.query;
    this.updatingFromRoute = true;  
    if (page) this.page = +page;
    if (size) this.pageSize = +size;
    if (q !== undefined) this.q = q;
    if (sort) this.sort = sort;
    this.updatingFromRoute = false;
    this.fetchData(); 
  },
  methods: {
    rowKey(item, idx) { return item.id ?? idx; },
    async fetchData() {
      if(this.loading) return;

      this.loading = true;
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const [res] = await Promise.all([
          api.get('/user/page', { params: { mfId, page: this.page, size: this.pageSize, sort: this.sort, query: this.q } }),
          new Promise(r => setTimeout(r, 600))
        ]);
        const r = res.data?.result || {};
        this.userList = r.items || [];
        this.totalItems = Number(r.total || 0);

        const pageCount = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
        if (this.page > pageCount) this.page = pageCount;
      } catch (e) {
        console.error("사용자 목록 불러오기 실패:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchData();
    },
    onRowClick(item, index){
      this.$router.push({
        name: "UserEdit",
        params: { id: item.emplyrId },
        query: {
          page: this.page,
          size: this.pageSize,
          q: this.q,
          sort: this.sort,
        },
      });
    },
    createData(){
      this.$router.push({
        name: "UserCreate",
      });
    }
  }
}
</script>
